import { useState } from 'react';
import { Grid } from '@material-ui/core';
import {Box} from '@mui/system';
import { Alert } from '@mui/material';
import PaginationControlled from './PaginationControlled';
import CSVReport from './CSVReport';
import CSVconLLU from "./CSVconLLU";
import "./annot.css"
import Stack from "@mui/material/Stack";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';





export default function Annot3({data}) {


        const [annotQueryInput, setAnnotQueryInput] = useState('');
    const [annotQueryResult, setAnnotQueryResult] = useState([]);
    const [message, setMessage] = useState('');
    const [transcription, setTranscription] = useState('dip');

    function poSSelect(e) {

        const opt = document.getElementsByClassName("opt");
        for (let i = 0; i < opt.length; i++) {
			opt[i].style.display = "none";
			opt[i].classList.remove("act");
		}

        const a = document.getElementById(e.target.value);

        if (a) {
            a.style.display = "";
		a.classList.add("act");
        }
	}


    	function poSWrite(e) {

            e.preventDefault()
            let pos = document.getElementById("PoS").value;
            if (pos !== "" ) {
                document.getElementById("input").value = pos;

            let tags = document.getElementsByClassName("act")[0]
                if (tags !== undefined) {
                    tags = tags.getElementsByClassName("tag")
                }


            if (tags !== undefined) {
			for (let i = 0; i < tags.length; i++) {
				pos += tags[i].value;
			}
			document.getElementById("input").value = pos;
		    }
            }

            let queryString = pos
            if (queryString.includes('?')) {
                  queryString = pos.replaceAll('?', '.');
            }

        setAnnotQueryInput(queryString)
	}


    const handleChangeTranscription = (event) => {
      setTranscription(event.target.value)
    };

    function handleChange(event) {

          let queryString = event.target.value
        if (event.target.value.includes('?')) {
            queryString = event.target.value.replaceAll('?', '.');
            queryString += ".*"
        }
        setAnnotQueryInput(queryString);

    }


    function handleSubmit(e) {
      e.preventDefault()

      let answer = []

      for (const text of data) {

        let token_index =  2
        const text_name = text['text']


        if (transcription === 'cyr') {
          token_index = 1
        } else if (transcription === 'lat') {
          token_index = 0
        }


        for (const [, sentence] of Object.entries(text['sentences'])) {

          let lemmata  = [];
          let annotations = [];
          let tokens = [];
          let UDs = [];
          let sent_plain = '';
          let translation = '';
          let annotationsExt = [];
          let UDsOfParents = [];
          let sentID = null;
          let re = new RegExp(annotQueryInput);


            for (const word of sentence) {
                sentID = word[6]
              sent_plain += word[token_index]
              sent_plain += ' '
              tokens.push(word[token_index])
              lemmata.push(word[3])
              annotations.push(word[4])
              UDs.push(word[9]);

              UDsOfParents.push(word[8]);
              word[5] ? annotationsExt.push(word[5]) : annotationsExt.push('_');

              if (word[13]) {
                translation += word[13]
                translation += ' / '
              }
            }

            for (let i = 0; i < annotations.length; i++) {
              if (annotations[i].startsWith(annotQueryInput) || annotations[i].match(re) ) {
             answer.push([sent_plain, text_name, tokens, lemmata, annotations, translation.slice(0, -2), UDs, i, annotationsExt, UDsOfParents,sentID  ])
            }
            }
        }

      }
      setAnnotQueryInput(annotQueryInput)
      setMessage(`Your query has given ${answer.length} results.`)
      setAnnotQueryResult(answer)
    }





    return (

        <>

             <Box sx={{ width: '100%'}} >
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} >
        <Grid item xs={6}>

            <Stack direction={'column'}>
          <input id="input" type="text" onChange={(e) => handleChange(e)} style={{width: "40%"}} placeholder={"*PoS tag"} />

        <select style={{width: "30%", marginTop: "20px"}}
          value={transcription}
          onChange={handleChangeTranscription}
        >
          <option value={'lat'}>Latin</option>
          <option value={'cyr'}>Cyrillic</option>
          <option value={'dip'}>Diplomatic</option>
        </select>

         <button  type='submit'  disabled={!annotQueryInput}  onClick={handleSubmit} style={{width: "80px", marginTop: "20px"}}>Submit</button>


            </Stack>

        </Grid>

        <Grid item xs={6}>
                   <form id="tagger" >
                       <form>
                           <select id="PoS"    onChange={(e) => poSSelect(e)} >
                               <option value="">select word category</option>
                               <option value="N">noun</option>
                               <option value="A">adjective</option>
                               <option value="P">pronoun</option>
                               <option value="M">numeral</option>
                               <option value="V">verb</option>
                               <option value="R">adverb</option>
                               <option value="S">preposition</option>
                               <option value="C">conjunction</option>
                               <option value="Q">particle</option>
                               <option value="I">interjection</option>
                               <option value="X">punctuation</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="N">
                           <select className="tag">
                               <option value="?">any gender</option>
                               <option value="f">feminine</option>
                               <option value="m">masculine</option>
                               <option value="n">neuter</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="?">any case form</option>
                               <option value="n">nominative (or nom/acc/inst)</option>
                               <option value="g">genitive (or gen/acc, gen/loc)</option>
                               <option value="d">dative (or dat/loc, dat/inst)</option>
                               <option value="a">accusative</option>
                               <option value="v">vocative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                               <option value="o">vowel article (m.sg -o)</option>
                               <option value="o">oblique (f.sg -ь)</option>
                               <option value="o">other article (RO only)</option>
                           </select>
                           <select className="tag">
                               <option value="">unspecified animacy</option>
                               <option value="y">animate</option>
                               <option value="n">inanimate</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="A">
                           <select className="tag">
                               <option value="?">any gender</option>
                               <option value="f">feminine</option>
                               <option value="m">masculine</option>
                               <option value="n">neuter</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="?">any case form</option>
                               <option value="n">nominative (or nom/acc/inst)</option>
                               <option value="g">genitive (or gen/acc, gen/loc)</option>
                               <option value="d">dative (or dat/loc, dat/inst)</option>
                               <option value="a">accusative</option>
                               <option value="v">vocative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                               <option value="o">vowel article (m.sg -o)</option>
                               <option value="o">oblique (f.sg -ь)</option>
                           </select>
                           <select className="tag">
                               <option value="?">any complexity</option>
                               <option value="y">long-form</option>
                               <option value="n">short-form</option>
                           </select>
                           <select className="tag">
                               <option value="">no degree</option>
                               <option value="c">comparative</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="P">
                           <select className="tag">
                               <option value="?">any type</option>
                               <option value="d">demonstrative</option>
                               <option value="i">indefinite</option>
                               <option value="p">personal</option>
                               <option value="q">interrogative</option>
                               <option value="r">relative</option>
                               <option value="s">possessive (RO only)</option>
                               <option value="x">reflexive</option>
                               <option value="z">negative</option>
                           </select>
                           <select className="tag">
                               <option value="?">any person</option>
                               <option value="-">unspecified</option>
                               <option value="1">1</option>
                               <option value="2">2</option>
                               <option value="3">3</option>
                           </select>
                           <select className="tag">
                               <option value="?">any gender</option>
                               <option value="f">feminine</option>
                               <option value="m">masculine</option>
                               <option value="n">neuter</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="">any case form</option>
                               <option value="n">nominative (or nom/acc)</option>
                               <option value="g">genitive (or gen/acc, gen/loc)</option>
                               <option value="d">dative (or dat/loc, dat/inst)</option>
                               <option value="a">accusative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                               <option value="o">oblique (f.sg -ь)</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="V">
                           <select className="tag">
                               <option value="?">any type</option>
                               <option value="m">main</option>
                               <option value="a">auxiliary</option>
                           </select>
                           <select className="tag">
                               <option value="?">any mood/form</option>
                               <option value="i">indicative</option>
                               <option value="m">imperative</option>
                               <option value="n">infinitive</option>
                               <option value="o">conditional</option>
                               <option value="p">participle</option>
                               <option value="s">subjunctive (RO only)</option>
                           </select>
                           <select className="tag">
                               <option value="?">any tense</option>
                               <option value="-">unspecified</option>
                               <option value="p">present</option>
                               <option value="a">aorist</option>
                               <option value="i">imperfect</option>
                               <option value="l">pl.perfect (RO only)</option>
                           </select>
                           <select className="tag">
                               <option value="?">any person</option>
                               <option value="-">unspecified</option>
                               <option value="1">1</option>
                               <option value="2">2</option>
                               <option value="3">3</option>
                           </select>
                           <select className="tag">
                               <option value="?">any number</option>
                               <option value="s">singular</option>
                               <option value="d">dual</option>
                               <option value="p">plural</option>
                           </select>
                           <select className="tag">
                               <option value="">any aspect</option>
                               <option value="i">imperfective</option>
                               <option value="e">perfective</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="M">
                           <select className="tag">
                               <option value="">any type</option>
                               <option value="d">Arabic (digit)</option>
                               <option value="c">Cyrillic (alphabetic)</option>
                               <option value="r">Roman</option>
                               <option value="l">nominal</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="R">
                           <select className="tag">
                               <option value="">any degree</option>
                               <option value="c">comparative</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="S">
                           <select className="tag">
                               <option value="">any case (governed)</option>
                               <option value="g">genitive</option>
                               <option value="d">dative</option>
                               <option value="a">accusative</option>
                               <option value="l">locative</option>
                               <option value="i">instrumental</option>
                           </select>
                       </form>

                       <form className="opt" style={{display:"none"}} id="Q">
                           <select className="tag">
                               <option value="">any type</option>
                               <option value="c">comparative</option>
                               <option value="d">demonstrative</option>
                               <option value="g">general</option>
                               <option value="o">modal</option>
                               <option value="q">interrogative</option>
                               <option value="z">negative</option>
                           </select>
                       </form>

                       <br/><input className='submitBtn'
                                   type="submit" value="write PoS tag"
                                   onClick={(e) => poSWrite(e)}/>
                   </form>
        </Grid>
      </Grid>
    </Box>



      <Box mt={2}>

      {message && <Alert severity="info">{message}</Alert>}

      </Box>

      <CSVReport searchResult={annotQueryResult}   domain="annot"/>
          <br/>
          <CSVconLLU searchResult={annotQueryResult} />

    <br/>

      <PaginationControlled queryResult={annotQueryResult} query={annotQueryInput} domain="annot"  trans={transcription} />


            </>
    );
  }
